"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMTargetFunctionsMode = void 0;
const Utils_1 = require("../../utils/Utils");
exports.VMTargetFunctionsMode = Utils_1.Utils.makeEnum({
    Root: 'root',
    Comment: 'comment'
});
